import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomButton from 'components/common/CustomButton';
import CustomInput from 'components/common/CustomInput';
import { toast } from 'react-toastify';
import axios from 'axios';
import Timer from 'components/common/Timer';
import PageTemplate from 'components/template/PageTemplate';
import { ReactComponent as Fin } from 'assets/common/pwfin.svg'
import { ReactComponent as EyeOn } from 'assets/common/eyeOn.svg'
import { ReactComponent as EyeOff } from 'assets/common/eyeOff.svg'
import { correctPw } from 'components/common/regex';
import { encryptAES } from 'components/encryptDecrpt';

const ResetPW = () => {
    const navigate = useNavigate();

    // 회원가입 정보 추가예정
    const [email, setEmail] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [timeKey, setTimeKey] = useState<number>(0);
    const [isTimeOut, setIsTimeOut] = useState<boolean>(false)
    const [authCode, setAuthCode] = useState<string>('');
    const [serverAuthCode, setServerAuthCode] = useState<string>('');
    const [tab, setTab] = useState<number>(0);
    const [pw1, setPw1] = useState<string>('');
    const [pw2, setPw2] = useState<string>('');
    const [pwShow1, setPwShow1] = useState<boolean>(false);
    const [pwShow2, setPwShow2] = useState<boolean>(false);
    const [pwErrors, setPwErrors] = useState({ pw1: false, pw2: false });
    const [pwCheck, setPwCheck] = useState<boolean>(false);
    const [userId, setUserId] = useState<number>(0);

    useEffect(() => {
        if (authCode.length > 5) {
            if (encryptAES(authCode) !== serverAuthCode) {
                toast.error('인증번호가 일치 하지 않습니다.');
                return;
            }
            const reqData = {
                email: email,
                code: authCode
            }
            postCode(reqData).then(res => {
                if (res.data.code === 200) {
                    const reqData = {
                        email: email
                    }
                    postCheckEmail(reqData).then(res => {
                        if (res.data.code === 200) {
                            toast.success('정상적으로 인증되었습니다.')
                            setUserId(res.data.data.id)
                            setTab(1)
                            setAuthCode('')
                            setServerAuthCode('')
                        }
                        else {
                            toast.error('가입된 이메일이 아닙니다.')
                            setAuthCode('')
                            setServerAuthCode('')
                            setTimeKey(0)
                        }
                    })
                }
                else if (res.data.code === 400) {
                    toast.error('인증번호가 일치하지않습니다.')
                }
            })
        }
    }, [authCode, serverAuthCode, email])

    useEffect(() => {
        if (pw1.length > 7 && pw2.length > 7) {
            setPwCheck(pw1 === pw2 && !pwErrors.pw1 && !pwErrors.pw2);
        }
        else {
            setPwCheck(false)
        }
    }, [pw1, pw2, pwErrors])

    const sendEmail = (reSend?: boolean) => {
        if (!email) return toast.error('이메일을 입력해주세요.')
        setLoading(true)
        const reqData = {
            email: email,
            status: 'reset',
        }
        postVerifyEmail(reqData).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                toast.success('인증번호를 발송했습니다.')
                setServerAuthCode(res.data.data)
                !reSend && setTimeKey(1)
            }
            else if (res.data.code === 400) {
                toast.error('존재하지 않는 이메일입니다.')
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    const reSendEmail = () => {
        sendEmail(true);
        setIsTimeOut(false)
        setAuthCode('')
        setTimeKey(k => k + 1)
    }

    const goLogin = () => {
        navigate(-1)
    }

    const resetPassword = () => {
        // 비밀번호 저장하는 로직
        const reqData = {
            userId: userId,
            newPassword: pw1
        }
        postReset(reqData).then(res => {
            if (res.data.code === 200) {
                setTab(2)
            }
            else {
                toast.error('비밀번호 재설정에 실패했습니다.')
            }
        })
    }

    const postVerifyEmail = async (reqData: object) => {
        const url = `${process.env.REACT_APP_API_URL2}verifyEmail`
        return await axios.post(url, reqData)
    }

    const postReset = async (reqData: object) => {
        const url = `${process.env.REACT_APP_API_URL}signin/reset`
        return await axios.post(url, reqData)
    }

    const postCheckEmail = async (reqData: object) => {
        const url = `${process.env.REACT_APP_API_URL}check/email`
        return await axios.post(url, reqData)
    }

    const postCode = async (reqData: object) => {
        const url = `${process.env.REACT_APP_API_URL}verify/code`
        return await axios.post(url, reqData)
    }

    const checkPw = (key: 'pw1' | 'pw2', pw: string) => {
        setPwErrors(prev => ({ ...prev, [key]: pw ? !correctPw(pw) : false }));
    };

    return (
        <PageTemplate background='bg-[#f8f8f8]' isFooter={false}>
            <div className='flex flex-col justify-center items-center gap-4 py-30 mobile:py-0 h-dvh mobile:h-[calc(100dvh-80px)]'>
                <div className='flex flex-col mobile:items-center gap-4 mobile:w-full'>
                    <div className="relative flex flex-col justify-center items-center bg-white px-10 mobile:px-6 mobile:py-10 pb-15 rounded-3xl w-[600px] mobile:w-9/10">
                        <p className="py-19 mobile:py-10 font-semibold mobile:text-lg text-2xl">비밀번호 재설정 {tab === 2 && '완료'}</p>

                        {
                            tab === 0 ?
                                <div className='flex flex-col justify-between mobile:gap-3 w-full min-h-[284px] mobile:min-h-0'>
                                    <CustomInput
                                        type={'email'}
                                        placeholder={'이메일을 입력해주세요'}
                                        onChange={(e) => {
                                            setEmail(e.target.value)
                                        }}
                                    />
                                    {
                                        serverAuthCode.length > 0 &&
                                        <>
                                            <div className='relative'>
                                                {
                                                    timeKey > 0 &&
                                                    <div className='right-6 absolute flex items-center h-full'>
                                                        <Timer
                                                            timerKey={timeKey}
                                                            isTimeOut={isTimeOut}
                                                            setIsTimeOut={setIsTimeOut}
                                                        />
                                                    </div>
                                                }

                                                <CustomInput
                                                    type={'text'}
                                                    value={authCode}
                                                    disabled={isTimeOut}
                                                    maxLength={6}
                                                    placeholder={'인증번호를 입력해주세요'}
                                                    onChange={(e) => {
                                                        setAuthCode(e.target.value)
                                                    }}
                                                />
                                            </div>
                                        </>
                                    }
                                    <p className='h-10 mobile:h-8'></p>
                                    {
                                        timeKey === 0 ?
                                            <CustomButton
                                                title='인증번호'
                                                loading={loading}
                                                className={`!min-w-0 h-15 bg-transparent !bg-primary text-white`}
                                                onClick={() => sendEmail()}
                                            /> :
                                            <CustomButton
                                                title='재요청'
                                                className='bg-red !min-w-0 h-15'
                                                onClick={() => reSendEmail()}
                                            />
                                    }
                                </div> :
                                tab === 1 ?
                                    <div className='flex flex-col justify-between mobile:gap-3 w-full min-h-[284px] mobile:min-h-0'>
                                        {[1, 2].map((num) => {
                                            const isShow = num === 1 ? pwShow1 : pwShow2;
                                            const setShow = num === 1 ? setPwShow1 : setPwShow2;
                                            const pwKey = num === 1 ? 'password' : 'password2';
                                            const pwChk = num === 1 ? pwErrors.pw1 : pwErrors.pw2;
                                            const setPw = num === 1 ? setPw1 : setPw2;
                                            const placeholder = num === 1 ? '새 비밀번호 입력' : '비밀번호 확인';

                                            return (
                                                <div className='relative w-full' key={num}>
                                                    <CustomInput
                                                        type={isShow ? 'text' : 'password'}
                                                        value={num === 1 ? pw1 : pw2}
                                                        name={pwKey}
                                                        error={pwChk}
                                                        placeholder={placeholder}
                                                        onBlur={(e) => checkPw(num === 1 ? 'pw1' : 'pw2', e.target.value)}
                                                        onChange={(e) => {
                                                            setPw(e.target.value);
                                                        }}
                                                    />
                                                    <div
                                                        className='top-0 right-6 absolute flex items-center h-full cursor-pointer'
                                                        onClick={() => setShow((prev) => !prev)}
                                                    >
                                                        {isShow ? <EyeOn /> : <EyeOff />}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                        <div className='h-10 mobile:h-8'>
                                            {(
                                                (pw1.length > 0 || pw2.length > 0) && (
                                                    (pw1.length < 8 || pw2.length < 8) ||
                                                    (pw1.length >= 8 && pw2.length >= 8 && (pwErrors.pw1 || pwErrors.pw2)) ||
                                                    (pw1.length >= 8 && pw2.length >= 8 && !pwErrors.pw1 && !pwErrors.pw2 && pw1 !== pw2)
                                                )
                                            ) && (
                                                    <p className="h-10 mobile:h-8 text-red text-xs text-center">
                                                        {(
                                                            (pw1.length < 8 || pw2.length < 8) ||
                                                            (pw1.length >= 8 && pw2.length >= 8 && (pwErrors.pw1 || pwErrors.pw2))
                                                        ) ? (
                                                            <>
                                                                비밀번호는 영문 대문자 숫자 특수문자를 포함한<br />
                                                                8자리 이상이어야 합니다.
                                                            </>
                                                        ) : (
                                                            <>비밀번호가 일치하지 않습니다.</>
                                                        )}
                                                    </p>
                                                )}
                                        </div>

                                        <CustomButton
                                            title='재설정하기'

                                            disabled={!pwCheck}
                                            className={`!min-w-0 h-15 bg-transparent text-white ${(pwCheck) ? '!bg-primary ' : ''}`}
                                            onClick={resetPassword}
                                        />
                                    </div> :
                                    <div className='flex flex-col justify-between items-center w-full min-h-[284px]'>
                                        <Fin />
                                        <p className='mb-4 h-10 text-center'>
                                            비밀번호 재설정이 완료되었습니다.<br />
                                            변경 된 비밀번호로 로그인 하시기 바랍니다.
                                        </p>
                                        <CustomButton
                                            title='로그인'
                                            className={`!min-w-0 h-15 w-full bg-transparent !bg-primary text-white`}
                                            onClick={goLogin}
                                        />
                                    </div>
                        }
                    </div>
                </div>
            </div>
        </PageTemplate>
    );
}

export default ResetPW;